import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { AuthGuard, ConfigModule, I18nModule, provideConfig } from '@spartacus/core'
import { translationOverwrites } from '../../../../../public/asaleocare.translate'
import { CustomCardModule } from '../../shared/card/card.module'
import { MaterialModule } from '../../shared/material.module'
import { CustomAddressBookComponent } from './custom-address-book.component'

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MaterialModule,
    CustomCardModule,
    ConfigModule.withConfig({
      i18n: { resources: translationOverwrites }
    })
  ],
  declarations: [CustomAddressBookComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        AccountAddressBookComponent: {
          component: CustomAddressBookComponent,
          guards: [AuthGuard]
        }
      }
    })
  ]
})
export class CustomAddressBookModule {}
